export default __webpack_public_path__ + "static/media/agnidus_agate_gemstone.f23ea18b.png";